// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2gS6R","content":"RecentSearches_content__lEoYp"};